// import axios from 'axios';
import {
    isEnglishString,
    isChineseString,
    saveLocalStorage,
    getLocalStorage
} from '../util/util';
import {Http, urls} from '../api/index';
const LASTEST_CITY = 'LASTEST_CITY';

function initialAllCity() {
    const city = {};
    for (let i = 0; i < 26; i++) {
        city[String.fromCharCode(65 + i)] = [];
    }
    return city;
}

function filterCity(cityList) {
    const validateLetters1 = [];
    const allCity = {};
    const hotCity = [];
    for (let i = 0; i < cityList.data.length; i++) {
        let key = cityList.data[i]['firstLetter'];
        let item = cityList.data[i];
        if (!allCity.hasOwnProperty(key)) {
            allCity[key] = [];
            allCity[key].push({
                cityName: item.cityName,
                en: item.citySpell,
                cityId: item.cityId,
                pid: item.provinceId,
                coordinatePoint: item.coordinatePoint
            });
        } else {
            allCity[key].push({
                cityName: item.cityName,
                en: item.citySpell,
                cityId: item.cityId,
                pid: item.provinceId,
                coordinatePoint: item.coordinatePoint
            });
        }
        if (cityList.data[i].hotCity === '1') {
            hotCity.push({
                cityName: item.cityName,
                en: item.citySpell,
                cityId: item.cityId,
                pid: item.provinceId,
                coordinatePoint: item.coordinatePoint
            });
        }
        validateLetters1.push(cityList.data[i]['firstLetter']);
    }

    let validateLetters = Array.from(new Set(validateLetters1));
    return {
        validateLetters,
        allCity,
        hotCity
    };
}

function formatCites(json) {
    const afterFilterAllCity = filterCity(json);
    return {
        afterFilterAllCity
    };
}

function hasInCityResultList(city, result) {
    return result.some(r => {
        return r.id === city.id;
    });
}

function searchCityListByChineseKey(key, allCity) {
    const result = [];
    Object.keys(allCity).forEach(cityCode => {
        const cityCollection = allCity[cityCode];
        cityCollection.forEach(city => {
            if (city.cityName.includes(key) && !hasInCityResultList(city, result)) {
                result.push(city);
            }
        });
    });

    return result;
}

function searchCityListByEnglishKey(key, labels, allCity) {
    let result = [];
    const firstLetter = key.toUpperCase()[0];

    if (!labels.includes(firstLetter)) {
        return result;
    }
    
    allCity[firstLetter].forEach(city => {
        if (city.en) {
            if (city.en.includes(key) && !hasInCityResultList(city, result)) {
                result.push(city);
            }
        }
    });

    return result;
}

function searchCityByName(key, labels, allCity) {
    let result = [];

    if (!key.length) {
        return result;
    }
    
    if (isChineseString(key)) {
        result = searchCityListByChineseKey(key, allCity);
    } else if (isEnglishString(key)) {
        result = searchCityListByEnglishKey(key, labels, allCity);
    }

    return result;
}

async function getAllCities() {
    let url = urls.initCityDic;
    let res = await Http.post({url});
    return formatCites(res);
}

function saveLocalStorageCity(key, city) {
    const lastestCity = getLocalStorageCity(key);
    if (!lastestCity.includes(city)) {
        if (lastestCity.length >= 2) {
            lastestCity.splice(0, 1);
        }
        lastestCity.push(city);
        saveLocalStorage(key, lastestCity.join(':'));
    }

    return lastestCity;
}

function getLocalStorageCity(key) {
    const cityInfo = getLocalStorage(key);
    return cityInfo ? cityInfo.split(':') : []; 
}

function transformCityMenuData(city) {
    return city.map(c => ({
        value: JSON.stringify(c),
        label: c.cityName
    }));
}

export {
    LASTEST_CITY,
    getAllCities,
    searchCityByName,
    initialAllCity,
    filterCity,
    formatCites,
    hasInCityResultList,
    searchCityListByChineseKey,
    searchCityListByEnglishKey,
    saveLocalStorageCity,
    getLocalStorageCity,
    transformCityMenuData
}